 
const supportedCurrencies =['EUR', 'GBP', 'USD'];

export const isFiat = (currency: string): boolean => { 
    return supportedCurrencies.includes(currency);
};
